import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { EyeIcon } from "@phosphor-icons/react/dist/csr/Eye";
import { EyeSlashIcon } from "@phosphor-icons/react/dist/csr/EyeSlash";
import { forwardRef, useState } from "react";

const PasswordTextField = forwardRef<HTMLButtonElement, TextFieldProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      inputRef={ref}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
});
PasswordTextField.displayName = "PasswordTextField";
export default PasswordTextField;
